import React, { Component } from 'react'
import { Drawer, Row, message, Col, Select, Tooltip, Alert, Button } from 'antd'
import { Form } from '@ant-design/compatible';
import PropTypes from 'prop-types'

import SubmitButton from '../../shared/components/submit/SubmitButton';
import InputDecimal from '../../shared/components/inputs/decimal/InputDecimal';
import InputSwitch from "../../shared/components/inputs/switch/InputSwitch";
import InputSelect from "../../shared/components/inputs/select/InputSelect";
import InputText from "../../shared/components/inputs/text/InputText";
import {ConfiguracaoService} from "../../shared/services/http/ConfiguracaoService";
import {withAppInsightsTracking} from "../../shared/services/AppInsightsService";
import { Icon } from '@ant-design/compatible';

const inputs = {
  ratio: {
    name: 'raioAtual',
    placeholder: 'Raio',
    rules: [{ required: true, message: 'Raio é obrigatório!' }]
  },
  contribuition: {
    name: 'percentualContribuicao',
    placeholder: 'Percentual de Contribuição',
    rules: [{ required: true, message: 'Percentual de Contribuição é obrigatório!' }]
  },
  anticipation: {
    name: 'percentualTaxaAntecipacao',
    placeholder: 'Percentual de Antecipação',
  },
  appPayment: {
    name: 'percentualTaxaPagamentoApp',
    placeholder: 'Percentual de Pagamento App',
  },
  cancelation: {
    name: 'taxaCancelamento',
    placeholder: 'Taxa de Cancelamento',
  },
  service: {
    name: 'taxaServico',
    placeholder: 'Taxa de Serviço',
  },
  waitingClient: {
    name: 'taxaEsperaCliente',
    placeholder: 'Taxa de Espera do Cliente',
  },
  smsService: {
    name: 'servicoSMS',
    placeholder: 'Serviço SMS',
  },
  notificationSendingTime: {
    name: 'tempoEnvio',
    placeholder: 'Tempo de envio de notificação WhatsApp'
  },
  cancellationTime: {
    name: 'tempoCancelamento',
    placeholder: 'Tempo de Cancelamento'
  },
  habilitarCupom: {
    name: 'habilitarCupom',
    placeholder: 'Habilitar Cupom'
  },
  smsValidationDisabled: {
    name: 'desativadaValidacaoSMS',
    placeholder: 'Desativar Validação de SMS',
    rules: []
  },
  bonusNewClient: {
    name: 'valorBonusNovoCliente',
    placeholder: 'Bônus para novos clientes',
  },
  waitingTimeLimit: {
    name: 'tempoLimiteEsperaCliente',
    placeholder: 'Tempo limite de espera',
  },
  delayedOrderBonus: {
    name: 'valorBonusPedidoAtrasado',
    placeholder: 'Bônus por pedido atrasado',
    rules: []
  }
}

class ConfiguracaoGeralFormulario extends Component {
  state = {
    loading: false,
    showWhatsappAlert: false
  }

  beforeClose = () => {
    this.props.form.resetFields()
    this.props.form.validateFields()
    this.props.onClose(this.props.form.resetFields)
  }

  toggleLoading = (callBack) => this.setState(prevState => ({ loading: !prevState.loading }), callBack)

  update = async values => {
    try {
      await ConfiguracaoService().update(values)

      this.toggleLoading(() => {
        this.beforeClose()
        message.success('Configurações alteradas com sucesso!')
      })
    } catch (error) {
      this.toggleLoading(() => message.error(error))
    }
  }

  handleSubmit = event => {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        const updatedConfiguration = { ...this.props.configuration };

        Object.keys(values).forEach(key => {
          if (key === 'desativadaValidacaoSMS') {
            updatedConfiguration[key] = !values[key];
          } else if (values[key] !== this.props.configuration[key]) {
            updatedConfiguration[key] = values[key];
          }
        });

        this.toggleLoading(() => this.update(updatedConfiguration));
      }
    });
  }

  handleShowWhatsappAlert = () => {
    this.setState({ showWhatsappAlert: true });
  }

  handleCloseWhatsappAlert = () => {
    this.setState({ showWhatsappAlert: false });
  }

  render() {
    const { isOpen, form, configuration } = this.props
    const { loading, showWhatsappAlert } = this.state

    return (
      <Drawer
        title={<span style={{fontSize: '24px', fontWeight: 600}}>Configurações</span>}
        width={700}
        onClose={this.beforeClose}
        visible={isOpen}
      >
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <h3 style={{ color: '#1976d2', marginBottom: 0, marginTop: 10 }}>Operação</h3>
          <div style={{ borderBottom: '1px solid #e0e0e0', margin: '8px 0' }} />
          <div style={{ marginBottom: 10, marginTop: 5 }}>
            <span style={{ color: '#666' }}>
              Atenção! Esse parâmetro vai alterar o raio de alcance do dispositivo dos clientes para encontrar revendas! Todos os clientes serão afetados!
            </span>
          </div>
          <Row gutter={14} style={{ marginBottom: 24 }}>
            <Col span={8}>
              <span>{inputs.ratio.placeholder}</span>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                <InputDecimal
                  initialValue={configuration.raioAtual}
                  form={form}
                  name={inputs.ratio.name}
                  placeholder={inputs.ratio.placeholder}
                  rules={inputs.ratio.rules} />
              </div>
            </Col>
            <Col span={8}>
              <span>{inputs.cancellationTime.placeholder}</span>
              <Row>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                  <InputText
                    initialValue={configuration.tempoCancelamento}
                    placeholder={'0'}
                    name={inputs.cancellationTime.name}
                    form={form}
                  />
                  <Button type="button" disabled style={{marginTop: -18}} >Minutos</Button>
                </div>
              </Row>
            </Col>
            <Col span={8}>
              <span>{inputs.waitingTimeLimit.placeholder}</span>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                <InputText
                  initialValue={configuration.tempoLimiteEsperaCliente}
                  placeholder={'0'}
                  name={inputs.waitingTimeLimit.name}
                  form={form}
                />
                <Button type="button" disabled style={{marginTop: -18}} >Minutos</Button>
              </div>
            </Col>
          </Row>

          <Row gutter={14} style={{ marginBottom: 24 }}>
            <Col span={8}>
              <span>{inputs.bonusNewClient.placeholder}</span>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                <InputDecimal
                  initialValue={configuration.valorBonusNovoCliente}
                  form={form}
                  name={inputs.bonusNewClient.name}
                  placeholder={inputs.bonusNewClient.placeholder}
                  rules={inputs.bonusNewClient.rules} />
              </div>
            </Col>
            <Col span={8}>
              <span>{inputs.delayedOrderBonus.placeholder}</span>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                <InputDecimal
                  initialValue={configuration.valorBonusPedidoAtrasado}
                  form={form}
                  name={inputs.delayedOrderBonus.name}
                  placeholder={inputs.delayedOrderBonus.placeholder}
                  rules={inputs.delayedOrderBonus.rules} />
              </div>
            </Col>
          </Row>

          <h3 style={{ color: '#1976d2', marginBottom: 0 }}>Balanços</h3>
          <div style={{ borderBottom: '1px solid #e0e0e0', margin: '8px 0' }} />
          <Row gutter={14} style={{ marginBottom: 24 }}>
            <Col span={8}>
              <span>{inputs.cancelation.placeholder}</span>
              <InputDecimal
                initialValue={configuration.taxaCancelamento}
                form={form}
                name={inputs.cancelation.name}
                placeholder={inputs.cancelation.placeholder} />
            </Col>
            <Col span={8}>
              <span>{inputs.service.placeholder}</span>
              <InputDecimal
                initialValue={configuration.taxaServico}
                form={form}
                name={inputs.service.name}
                placeholder={inputs.service.placeholder} />
            </Col>
            <Col span={8}>
              <span>{inputs.waitingClient.placeholder}</span>
              <InputDecimal
                initialValue={configuration.taxaEsperaCliente}
                form={form}
                name={inputs.waitingClient.name}
                placeholder={inputs.waitingClient.placeholder} />
            </Col>
            <Col span={8} style={{ marginTop: 16 }}>
              <span>{inputs.anticipation.placeholder}</span>
              <InputDecimal
                initialValue={configuration.percentualTaxaAntecipacao}
                form={form}
                name={inputs.anticipation.name}
                placeholder={'0'} />
            </Col>
            <Col span={8} style={{ marginTop: 16 }}>
              <span>{inputs.contribuition.placeholder}</span>
              <InputDecimal
                initialValue={configuration.percentualContribuicao}
                form={form}
                name={inputs.contribuition.name}
                placeholder={inputs.contribuition.placeholder}
                rules={inputs.contribuition.rules} />
            </Col>
            <Col span={8} style={{ marginTop: 16 }}>
              <span>{inputs.appPayment.placeholder}</span>
              <InputDecimal
                initialValue={configuration.percentualTaxaPagamentoApp}
                form={form}
                name={inputs.appPayment.name}
                placeholder={inputs.appPayment.placeholder} />
            </Col>
          </Row>

          <h3 style={{ color: '#1976d2', marginBottom: 0 }}>Serviço de envio</h3>
          <div style={{ borderBottom: '1px solid #e0e0e0', margin: '8px 0' }} />
          <Row gutter={14} style={{ marginBottom: 24 }}>
            <Col span={8}>
              <div>
                <span style={{ marginRight: 8 }}>Validação de SMS</span>
                <InputSwitch
                  initialValue={!configuration.desativadaValidacaoSMS}
                  form={form}
                  name={inputs.smsValidationDisabled.name}
                  placeholder={inputs.smsValidationDisabled.placeholder}
                  rules={inputs.smsValidationDisabled.rules} />
              </div>
              <div>
                <span>Serviço SMS</span>
                <InputSelect
                  initialValue={{ 1: "Comtele", 2: "Yup" }[configuration.servicoSMS]}
                  data={[{ value: 1, text: "Comtele" }, { value: 2, text: "Yup" }]}
                  placeholder='Serviço SMS'
                  name={inputs.smsService.name}
                  form={form}
                />
              </div>
              <div>
                <span>{inputs.habilitarCupom.placeholder}</span>
                <InputSwitch
                  initialValue={configuration.habilitarCupom}
                  form={form}
                  name={inputs.habilitarCupom.name}
                  placeholder={inputs.habilitarCupom.placeholder}
                  rules={inputs.habilitarCupom.rules} />
              </div>
            </Col>
            <Col span={16}>
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ width: 220 }}>
                  <span>Envio de notificação WhatsApp</span>
                  <Icon
                    type='info-circle'
                    style={{ fontSize: '16px', color: '#F5963F', marginLeft: 8, cursor: 'pointer' }}
                    onClick={this.handleShowWhatsappAlert}
                  />
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                    <InputText
                      initialValue={configuration.tempoEnvio}
                      placeholder={'0'}
                      name={inputs.notificationSendingTime.name}
                      form={form}
                      style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                    />
                    <Button type="button" disabled style={{marginTop: -18}} >Segundos</Button>
                  </div>
                </div>
              </div>
              {showWhatsappAlert && (
                <Alert
                  style={{ gridColumn: 'span 3', borderColor: "#E3E3E3", backgroundColor: "transparent", marginTop: 12 }}
                  description="Para receber notificações no WhatsApp após um pedido, certifique-se de ativar a 'Notificação pelo WhatsApp' nas configurações da organização. Após a ativação, a revenda receberá a notificação conforme o tempo configurado."
                  showIcon
                  type='warning'
                  closable
                  onClose={this.handleCloseWhatsappAlert}
                />
              )}
            </Col>
          </Row>

          <Row gutter={14} style={{ marginBottom: 24 }}>
            {/* <Col span={8}>
              <span>{inputs.habilitarCupom.placeholder}</span>
              <InputSwitch
                initialValue={configuration.habilitarCupom}
                form={form}
                name={inputs.habilitarCupom.name}
                placeholder={inputs.habilitarCupom.placeholder}
                rules={inputs.habilitarCupom.rules} />
            </Col> */}
          </Row>

          <Form.Item>
            <Row gutter={14} type="flex" justify="end">
              <SubmitButton
                cssClass="save-driver-button"
                form={form}
                type="primary"
                loading={loading}
                text="Salvar"
              />
            </Row>
          </Form.Item>
        </Form>
      </Drawer>
    )
  }
}

ConfiguracaoGeralFormulario = Form.create()(ConfiguracaoGeralFormulario)

ConfiguracaoGeralFormulario.propTypes = {
  isOpen: PropTypes.bool,
  configuration: PropTypes.object,
  form: PropTypes.object,
}

export default withAppInsightsTracking(ConfiguracaoGeralFormulario)
